import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import DashboardPage from "./dashboard/DashboardPage";
import { LayoutSplashScreen } from "../../../_metronic";

const UsuarioPage = lazy(() => import("./usuario/UsuarioPage"));
const ExercicioPage = lazy(() => import("./exercicio/ExercicioPage"));
const LocalPage = lazy(() => import("./local/LocalPage"));
const AulaPage = lazy(() => import("./aula/AulaPage"));
const AdminPage = lazy(() => import("./admin/AdminPage"));
const GrupoUsuario = lazy(() => import("./grupo/GrupoUsuarioPage"));
const RelatorioPage = lazy(() => import("./relatorio/RelatorioPage"));
const NotificacaoPage = lazy(() => import("./notificacao/NotificacaoPage"));
const ProgramaPage = lazy(() => import("./programa/ProgramaPage"));
const BioimpedanciaPage = lazy(() => import("./bioimpedancia/BioimpedanciaPage"));

export default function HomePage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <Redirect exact from="/" to="/dashboard" />

                <Route path="/usuario/:id/bioimpedancia" component={BioimpedanciaPage} />
                <Route path="/dashboard" component={DashboardPage} />
                <Route path="/admin" component={AdminPage} />
                <Route path="/exercicio" component={ExercicioPage} />
                <Route path="/local" component={LocalPage} />
                <Route path="/aula" component={AulaPage} />
                <Route path="/usuario" component={UsuarioPage} />
                <Route path="/grupo" component={GrupoUsuario} />
                <Route path="/relatorio" component={RelatorioPage} />
                <Route path="/notificacao" component={NotificacaoPage} />
                <Route path="/programa" component={ProgramaPage} />

                <Redirect to="/error/error-v6" />
            </Switch>
        </Suspense>
    );
}
